import React, { useState } from "react";
import {
    Button,
    Heading,
    VStack,
    Text,
    Input,
    FormControl,
    FormErrorMessage,
    FormLabel,
    InputGroup,
} from "@chakra-ui/react";
import { useNavigate } from 'react-router';
import { CountryCodeSelect } from "../CountryCodeSelect";
import { FormInput } from "../FormInput";

export const SignUp = ({
    singUpForm,
    handleFormChange,
    showCountryCode,
    codeChange,
    passwordError,
    error,
    signUp,
    isLoading,
}) => {
    const navigate = useNavigate();
    return (
        <VStack spacing={5}>
            <Heading as="h1" fontSize="2xl" width="full">Sign Up</Heading>
            <form onSubmit={signUp} style={{ width: "100%" }}>
                <VStack spacing={5}>
                    <FormControl
                        padding="0"
                        colorScheme="brand"
                        isRequired={true}
                        isInvalid={error.isError}
                    >
                        {error?.isSignUpError && (
                            <Text color="red.600" textAlign="center" padding="0 0 10px">
                                {error?.message}
                            </Text>
                        )}
                        <FormLabel>Email</FormLabel>
                        <InputGroup>
                            <Input
                                type="text"
                                name="username"
                                placeholder="Email"
                                value={singUpForm?.username}
                                errorBorderColor="red.300"
                                onChange={handleFormChange}
                                disabled={isLoading}
                            />
                        </InputGroup>
                        <FormErrorMessage display="block">
                            {error?.message}
                        </FormErrorMessage>
                    </FormControl>
                    <FormInput
                        label="Publisher Name"
                        name="publisherName"
                        type="text"
                        placeholder="Publisher Name"
                        inputOnChange={handleFormChange}
                        value={singUpForm?.publisherName}
                        formProps={{ isRequired: true }}
                        inputProps={{disabled: isLoading}}
                        padding="0"
                    />
                    <VStack spacing={0} width="100%" alignItems="flex-start">
                        <FormInput
                            label="Domain Name"
                            name="domainName"
                            type="text"
                            placeholder="https://test.myedshop.com/"
                            inputOnChange={handleFormChange}
                            value={singUpForm?.domainName}
                            formProps={{ isRequired: true }}
                            inputProps={{disabled: isLoading}}
                            padding="0"
                        />
                        <Text fontSize="xs">Domain name will be used to create personalized URL</Text>
                        {singUpForm?.domainName !== "" ? <Text fontSize="xs">Your store URL: https://{singUpForm?.domainName.replace(/\s+/g, "").toLowerCase()}.myedshop.com/</Text> : null}
                    </VStack>
                    <FormInput
                        label="First Name"
                        name="firstName"
                        type="text"
                        placeholder="Enter First Name"
                        inputOnChange={handleFormChange}
                        value={singUpForm?.firstName}
                        formProps={{ isRequired: true }}
                        inputProps={{disabled: isLoading}}
                        padding="0"
                    />
                    <FormInput
                        label="Last Name"
                        name="lastName"
                        type="text"
                        placeholder="Enter Family Name"
                        inputOnChange={handleFormChange}
                        value={singUpForm?.lastName}
                        formProps={{ isRequired: true }}
                        inputProps={{disabled: isLoading}}
                        padding="0"
                    />
                    <Button
                        colorScheme="blue"
                        _hover={{
                            bg: "blue.500",
                        }}
                        width="100%"
                        type="submit"
                        isLoading={isLoading}
                        loadingText='Signing up'
                    >
                        Sign Up
                    </Button>
                </VStack>
            </form>
            <Text>
                Already have an account? <Button variant="link" disabled={isLoading} colorScheme="blue" onClick={() => { navigate('/') }}>Sign In</Button>
            </Text>
        </VStack>
    );
};
